import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function TextRotateUpIcon(props: IconProps) {
    return <Icon {...props} iconKey={"text_rotate_up"}/>
}
